<template>
  <v-container 
    fluid 
    class="fill-height pt-0 pr-0"
  >
    <template v-if="posture">
      <v-row 
        class="px-3 mt-1" 
        style="height: 100%; overflow: hidden;"
      >
        <v-col
          v-if="isSideMenuOpened"
          cols="12"
          md="4"
          lg="3"
          class="pa-0 pr-3 d-flex flex-column"
        >
          <div class="d-flex align-center">
            <v-btn 
              icon
              large
              color="primary" 
              @click="fetchAll"
              class="mb-1"
            >
              <v-icon>mdi-reload</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="false"
              depressed
              large
              color="primary" 
              @click="isSideMenuOpened = false"
            >
              <v-icon>mdi-cog</v-icon>
              <v-icon>mdi-arrow-collapse-left</v-icon>
            </v-btn>
          </div>
          <simplebar style="flex: 1; height: 0; overflow-x: hidden;">
            <v-card 
              class="pa-0 mt-2 elevation-0"
              outlined
            >
              <v-card-title class="primary darken-3 white--text py-1">
                ID: {{ posture.id }}
                <v-spacer/>
                <Dialog 
                  color="accent"
                  ref="postureReportSelectorDiablog"
                  small
                >
                  <v-icon>mdi-swap-horizontal</v-icon>
                  <template #title>姿勢分析レポート切替</template>
                  <template #contents>
                    <PosturesTable
                      class="mt-3"
                      height="calc(100vh - 320px)"
                      :postures="postures"
                      elevation="0"
                      selectable
                      :filter-params="{
                        isDeleted: false,
                      }"
                      :invisible-headers-values="[
                        'isDeleted',
                      ]"
                      @select="
                        $refs.postureReportSelectorDiablog.close(); 
                        selectPostureReport($event);
                      "
                    />
                  </template>
                  <template #actions>
                    <span></span>
                  </template>
                </Dialog>
              </v-card-title>
              <v-card-text>
                <v-container class="px-0 pb-0">
                  <v-row dense>
                    <v-col>
                      <v-text-field
                        label="レポート名"
                        v-model="posture.name"
                        hide-details
                        @change="updatePostureAttribute('name')"
                      />
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col>
                      <v-textarea
                        label="説明"
                        class="mt-3"
                        v-model="posture.description"
                        @change="updatePostureAttribute('description')"
                      />
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col>
                      <v-select
                        label="有効/無効"
                        v-model="posture.isDeleted"
                        dense
                        hide-details
                        @change="updatePostureAttribute('isDeleted')"
                        :items="[
                          {label: '有効', value: false},
                          {label: '無効', value: true}
                        ]"
                        item-text="label"
                        item-value="value"
                      />
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col>
                      <v-text-field
                        label="作成日時"
                        v-model="posture.createdTime"
                        class="mt-5"
                        dense
                        hide-details
                        readonly
                        outlined
                      />
                    </v-col>
                  </v-row>
                  <v-btn
                    color="primary darken-2 my-2 py-1"
                    block
                    v-if="!isReportCommentsOpened"
                    @click="isReportCommentsOpened=true"
                  >
                    <v-icon>mdi-comment-text-multiple</v-icon>
                    <v-icon>mdi-unfold-more-horizontal</v-icon>
                  </v-btn>
                  <CommentsCard
                    class="pa-0 my-2 elevation-0"
                    :id="id"
                    target="posture"
                    outlined
                    v-if="isReportCommentsOpened"
                  >
                    <template #titleContainer>
                      <v-card-title 
                        class="primary darken-2 text-subtitle-1 white--text py-1 mb-3"
                        style="cursor: pointer;"
                        @click="isReportCommentsOpened=false"
                      >
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-comment-text-multiple</v-icon>
                        <v-icon color="white">mdi-unfold-less-horizontal</v-icon>
                        <v-spacer></v-spacer>
                      </v-card-title>
                    </template>
                  </CommentsCard>
                </v-container>
              </v-card-text>
            </v-card>
          </simplebar>
        </v-col>

        <v-col 
          v-if="posture.isAnalyzed && !posture.isFailed"
          cols="12" 
          :md="isSideMenuOpened ? 8 : null" 
          :lg="isSideMenuOpened ? 9 : null"
          class="d-flex flex-column pb-0"
        >
          <v-row 
            class="d-flex align-center pr-3" 
            style="flex: initial;"
            dense
          >
            <v-tabs 
              v-model="currentTabIndex" 
              class="mb-5"
              background-color="primary darken-2"
              dark
            >
              <v-tab
                v-for="tab in tabs"
                :key="tab.key"
              >{{ tab.label }}</v-tab>

              <v-spacer />
              <v-btn 
                color="accent"
                small
                class="my-auto mr-3"
                @click="downloadPose"
                v-tooltip.left="'xlsxファイルダウンロード'"
                :disabled="isDownloading"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-tabs>
          </v-row>
          <v-row 
            dense 
            v-if="posture.isAnalyzed"
            style="flex: 0 1 auto;"
          >
            <PostureGraphCard
              title="推定結果"
              v-bind="graphCols"
              :posture="posture"
              :averaged-poses="averagedPoses"
              :current-poses="currentPoses"
            />
            <v-col v-bind="graphCols">
              <v-row class="d-flex align-center">
                <v-chip
                  class="ml-3 my-0"
                  color="secondary"
                  outlined
                >
                  特徴量
                </v-chip>
              </v-row>
              <v-row>
                <v-col class="pt-1">
                  <PostureFeaturesTable
                    :posture="posture"
                    :averaged-poses="averagedPoses"
                    :current-poses="currentPoses"
                    :poses="poses"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row
                align="center" 
                dense
                class="mt-3"
              >
                <v-chip
                  outlined
                  color="secondary"
                >
                  分析対象
                </v-chip>
                <v-switch
                  dense
                  class="mt-0 ml-3"
                  v-model="isOutput"
                  color="primary"
                  hide-details
                  v-tooltip="'検出結果表示'"
                >
                </v-switch>
              </v-row>
              <v-row dense>
                <v-col cols="12">
                  <video 
                    v-if="posture.isVideo"
                    ref="video"
                    style="height: 50vh"
                    type="video/mp4"
                    :src="isOutput ? outputPath : inputPath"
                    @timeupdate="updateCurrentVideoPosition"
                    controls
                    muted
                  >
                    ブラウザがビデオの対応していません
                  </video>
                  <div 
                    v-else
                    class="d-flex flex-wrap"
                    style="gap: 8px;"
                    @dragleave.prevent 
                    @dragover.prevent 
                    @drop.prevent="selectAdditionalImages"
                  >
                    <div 
                      v-for="postureImageKey in postureImageKeys"  
                      :key="postureImageKey"
                      class="d-flex flex-column align-center"
                    >
                      <img                  
                        class="selectable-image"
                        :class="{
                          selected: selectedPostureImageKey == postureImageKey
                        }"
                        contain
                        :src="isOutput ? outputPath[postureImageKey] : inputPath[postureImageKey]"
                        @click.stop="selectedPostureImageKey = postureImageKey"
                      />

                      <v-switch
                        class="mt-0"
                        dense
                        hide-details
                        color="secondary"
                        label="有効"
                        v-model="postureImageValidationMap[postureImageKey]"
                      />
                    </div>

                    <label for="additionalImagesFileInput">
                      <div class="primary rounded px-5 py-1 file-button elavated">
                        <v-icon color="white">
                          mdi-plus
                        </v-icon>
                      </div>
                    </label>

                    <v-file-input
                      accept="image/*"
                      hide-input
                      multiple
                      class="d-none"
                      id="additionalImagesFileInput"
                      @change="selectAdditionalImages"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <template v-if="posture.isVideo">
              <v-col 
                cols="12"
                dense
                v-for="trackingPositionName in trackingPositionNames"
                :key="trackingPositionName"
              >
                <LineChart
                  :ref="`${trackingPositionName}LineChart`"
                  :height="240"
                />
              </v-col>
            </template>
          </v-row>
          <v-alert 
            v-if="!posture.isAnalyzed" 
            class="mt-5" 
            type="info" 
            color="primary"
          >
            分析中です。しばらくしてからリロードしてください。
          </v-alert>
        </v-col>
      </v-row>
    </template>
    <v-snackbar 
      :value="isDownloading"
      :timeout="-1"
      color="primary darken-4"
    >
      <span>Downloading...</span>
      <v-progress-linear
        indeterminate 
        :height="24"
        color="primary lighten-5"
        class="my-2 ml-1"
      />
    </v-snackbar>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import Dialog from "@components/parts/dialogs/Dialog.vue";

import PosturesTable from "@components/parts/tables/PosturesTable.vue";
import PostureFeaturesTable from "@components/parts/tables/PostureFeaturesTable.vue";
import CommentsCard from "@components/parts/cards/CommentsCard.vue";

import { mapState } from "vuex";
import LineChart from '@components/parts/charts/LineChart.vue'
import PostureGraphCard from '@components/parts/cards/PostureGraphCard.vue'

import { saveAs } from "file-saver";

export default {
  components: {
    Dialog,
    PosturesTable,
    PostureFeaturesTable,
    CommentsCard,
    PostureGraphCard,

    LineChart,
  },
  props: {
    id: {
      required: true,
    },
  },
  data: function(){
    return {
      isSideMenuOpened: true,
      isReportCommentsOpened: false,
      isLoading: false,
      isDownloading: false,
      posture: null,
      poses: [],
      isOutput: true,
      roll: -0*Math.PI/180, 
      pitch: -0*Math.PI/180, 
      yaw: -0*Math.PI/180,
      isDragging: false,
      cameraPosition: 2.5,
      currentVideoPosition: 0,
      isCurrentPoseVisible: true,
      isAveragedPoseVisible: true,
      currentTabIndex: 0,
      tabs: [
        {label: '分析結果', key: 'report'},
      ],
      trackingPositionNames: [
        "nose", //0
        "left_eye_inner", //1
        "left_eye", //2
        "left_eye_outer", //3
        "right_eye_inner", //4
        "right_eye", //5
        "right_eye_outer", //6
        "left_ear", //7
        "right_ear", //8
        "mouth_left", //9
        "mouth_right", //10
        "left_shoulder", //11
        "right_shoulder", //12
        "left_elbow", //13
        "right_elbow", //14
        "left_wrist", //15
        "right_wrist", //16
        "left_pinky", //17
        "right_pinky", //18
        "left_index", //19
        "right_index", //20
        "left_thumb", //21
        "right_thumb", //22
        "left_hip", //23
        "right_hip", //24
        "left_knee", //25
        "right_knee", //26
        "left_ankle", //27
        "right_ankle", //28
        "left_heel", //29
        "right_heel", //30
        "left_foot_index", //31
        "right_foot_index", //32
      ],
      graphCols: {
        cols: 12,
        sm: 6,
        lg: 6
      },
      maxFileSize: 100, //MB
      postureImageKeys: [],
      selectedPostureImageKey: null,
      postureImageValidationMap: {},
    }
  },
  computed: {
    ...mapState([
      'user',
      'rootPath',
      'postures',
    ]),
    rotatedCameraPosition: function(){
      const sinRoll = Math.sin(this.roll);
      const sinPitch = Math.sin(this.pitch);
      const sinYaw = Math.sin(this.yaw);

      const cosRoll = Math.cos(this.roll);
      const cosPitch = Math.cos(this.pitch);
      const cosYaw = Math.cos(this.yaw);


      let xWeights = [
        cosYaw*cosPitch,
        cosYaw*sinPitch*sinRoll - sinYaw*cosRoll,
        cosYaw*sinPitch*cosRoll + sinYaw*sinRoll,
      ];
      let yWeights = [
        sinYaw*cosPitch,
        sinYaw*sinPitch*sinRoll + cosYaw*cosRoll,
        sinYaw*sinPitch*cosRoll - cosYaw*sinRoll,
      ];
      let zWeights = [
        -sinPitch,
        cosPitch*sinRoll,
        cosPitch*cosRoll,
      ];

     return {
        x: xWeights[2]*this.cameraPosition,
        y: yWeights[2]*this.cameraPosition,
        z: zWeights[2]*this.cameraPosition,
      }
    },
    validPoses: function(){
      if(this.posture.isVideo){
        return this.poses;
      }

      const rtn = [];
      this.postureImageKeys.forEach((key, i) => {
        if(this.postureImageValidationMap[key]){
          rtn.push(this.poses[i]);
        }
      })
      return rtn;
    },
    averagedPoses: function(){
      if(this.validPoses.length == 0){
        return [];
      }

      if(this.validPoses.length == 1){
        return this.validPoses[0];
      }

      let averagedPositions = [];
      for(let i=0; i<33; i++){
        let averagedPosition = {
          x: 0,
          y: 0,
          z: 0,
        };
        let validCount = 0;
        this.validPoses.forEach(p => {
          if(p.length == 0){
            return;
          }

          if(p[i].visibility > 0.7){
            validCount++;
            averagedPosition.x += p[i].x;
            averagedPosition.y += p[i].y;
            averagedPosition.z += p[i].z;
          }
        });
        
        if(validCount > 0){
          averagedPosition.x /= validCount;
          averagedPosition.y /= validCount;
          averagedPosition.z /= validCount;
        }

        averagedPositions.push(
          averagedPosition
        );
      }

      for(let k=0; k<3; k++){
        let averagedDiffs = [];
        for(let i=0; i<33; i++){
          averagedDiffs.push([]);
        }
        this.validPoses.forEach(pose => {
          let diff = this.getDiff(
            this.getCenter(averagedPositions),
            this.getCenter(pose)
          );

          let transform = {
            dx: diff.x,
            dy: diff.y,
            dz: diff.z,
            dRoll: 0,
            dPitch: 0,
            dYaw: 0,
          };

          let step = 0.1;
          for(let i=0; i<3; i++){
            transform = {
              dx: transform.dx + this.getOptimizedParam(averagedPositions, pose, transform, 0, step),
              dy: transform.dy + this.getOptimizedParam(averagedPositions, pose, transform, 1, step),
              dz: transform.dz + this.getOptimizedParam(averagedPositions, pose, transform, 2, step),
              dRoll: transform.dRoll + this.getOptimizedParam(averagedPositions, pose, transform, 3, 1*step),
              dPitch: transform.dPitch + this.getOptimizedParam(averagedPositions, pose, transform, 4, 1*step),
              dYaw: transform.dYaw + this.getOptimizedParam(averagedPositions, pose, transform, 5, 1*step),
            }
            step *= 0.1;
          }


          for(let i=0; i<33; i++){
            if(pose.length == 0){
              continue;
            }
            if(pose[i].visibility > 0.7){
              let transformed = this.getTransformedPosition(
                pose[i], 
                transform.dx, transform.dy, transform.dz, 
                transform.dRoll, transform.dPitch, transform.dYaw,
              );
              averagedDiffs[i].push(this.getDiff(
                averagedPositions[i],
                transformed
              ));
            }
          }
        });
        let averagedDiff = [];
        for(let i=0; i<33; i++){
          let c = averagedDiffs[i].length;
          if(c <= 0){
            c = 1;
          }
          averagedDiff.push({
            x: averagedDiffs[i].reduce((prev,current) => prev + current.x, 0)/c,
            y: averagedDiffs[i].reduce((prev,current) => prev + current.y, 0)/c,
            z: averagedDiffs[i].reduce((prev,current) => prev + current.z, 0)/c,
          })
          averagedPositions[i] = {
            x: averagedPositions[i].x - averagedDiff[i].x,
            y: averagedPositions[i].y - averagedDiff[i].y,
            z: averagedPositions[i].z - averagedDiff[i].z,
          }
        }
      }

      return averagedPositions;
    },
    
    currentPoses: function(){
      if(this.poses.length == 0){
        return [];
      }

      if(this.posture.isVideo){
        let currentIndex = parseInt(this.currentVideoPosition*(this.poses.length - 1));
        return this.poses[currentIndex];
      }

      const index = this.postureImageKeys.indexOf(this.selectedPostureImageKey);
      return this.poses[index];
    },
  },
  watch: {
    id: function(){
      this.fetchAll();
    },
    poses: {
      handler: function(newVal){
        if(!newVal){
          return;
        }

        const attributes = [
          "x", "y", "z", 
          //"visibility",
        ];
        const defaultData = {
          fill: false,
          backgroundColor: 'hsla(0, 77%, 28%, 0.2)',
          borderColor: 'hsla(0, 77%, 28%, 0.2)',
          borderWidth: 2,
          label: '',
        };

        this.trackingPositionNames.forEach((n, i) => {
          let chartData = [];
          attributes.forEach((a, j) => {
            const color = `hsla(${120*j}, 77%, 28%, 0.2)`;
            chartData.push({
              ...defaultData,
              label: `${n} ${a}`,
              backgroundColor: color,
              borderColor: color,
              data: newVal.map((v, x) => ({
                x: x,
                y: v[i][a],
              })),
            });
          })

          this.$nextTick(() => {
            let components = this.$refs[`${n}LineChart`] ?? [];
            if(components.length == 0){
              return;
            }
            components[0].dataCollection.datasets = chartData;
            components[0].updateChart();
          });
        });
      },
      immediate: true,
    }
  },
  destroyed: function(){
  },
  mounted: function(){
    this.fetchPostureDetail();
  },
  beforeDestroy: function(){
  },
  methods: {
    fetchAll: function(){
      this.fetchPostureDetail();
    },
    getCenter: function(pose){
      const size = pose.length;
      return {
        x: pose.reduce((prev,current) => prev + current.x, 0)/size,
        y: pose.reduce((prev,current) => prev + current.y, 0)/size,
        z: pose.reduce((prev,current) => prev + current.z, 0)/size 
      }
    },
    getOptimizedParam: function(src, dst, transform, axis, step=0.1){
      let minRms = Number.MAX_SAFE_INTEGER;
      let minV = 0;
      for(let d=-10; d<=10; d++){
        let v = d*step;
        let _transform = {...transform};
        switch(axis){
          case 0:
            _transform.dx += v;
            break;
          case 1:
            _transform.dy += v;
            break;
          case 2:
            _transform.dz += v;
            break;
          case 3:
            _transform.dRoll += v;
            break;
          case 4:
            _transform.dPitch += v;
            break;
          case 5:
            _transform.dYaw += v;
            break;
        }

        let rms = 0;
        let validCount = 0;
        for(let i=0; i<33; i++){
          if(dst.length == 0){
            continue;
          }
          if(dst[i].visibility > 0.7){
            let transformed = this.getTransformedPosition(
              dst[i], 
              _transform.dx, _transform.dy, _transform.dz, 
              _transform.dRoll, _transform.dPitch, _transform.dYaw
            );
            rms += this.getSquaredDistance(transformed, src[i]);
            validCount++;
          }
        }
        rms = Math.sqrt(rms/validCount);
        if(rms < minRms){
          minRms = rms;
          minV = v;
        }
      }
      return minV;
    },
    getDiff: function(a, b){
      return {
        x: a.x - b.x,
        y: a.y - b.y,
        z: a.z - b.z,
      }
    },
    getSquaredDistance: function(pos1, pos2){
      return Math.pow(pos1.x - pos2.x, 2) + Math.pow(pos1.y - pos2.y, 2) + Math.pow(pos1.z - pos2.z, 2);
    },
    getTransformedPosition: function(srcPosition, dx, dy, dz, roll, pitch, yaw){
      const sinRoll = Math.sin(roll);
      const sinPitch = Math.sin(pitch);
      const sinYaw = Math.sin(yaw);

      const cosRoll = Math.cos(roll);
      const cosPitch = Math.cos(pitch);
      const cosYaw = Math.cos(yaw);

      let xWeights = [
        cosYaw*cosPitch,
        cosYaw*sinPitch*sinRoll - sinYaw*cosRoll,
        cosYaw*sinPitch*cosRoll + sinYaw*sinRoll,
      ];
      let yWeights = [
        sinYaw*cosPitch,
        sinYaw*sinPitch*sinRoll + cosYaw*cosRoll,
        sinYaw*sinPitch*cosRoll - cosYaw*sinRoll,
      ];
      let zWeights = [
        -sinPitch,
        cosPitch*sinRoll,
        cosPitch*cosRoll,
      ];
      return {
        x: srcPosition.x*xWeights[0] + srcPosition.y*xWeights[1] + srcPosition.z*xWeights[2] + dx,
        y: srcPosition.x*yWeights[0] + srcPosition.y*yWeights[1] + srcPosition.z*yWeights[2] + dy,
        z: srcPosition.x*zWeights[0] + srcPosition.y*zWeights[1] + srcPosition.z*zWeights[2] + dz,
      }
    },
    fetchPostureDetail: function(){
      this.isLoading = true;
      this.axios.get(`/api/posture/${this.id}`).then(response => {
        this.posture = response.data.posture;

        if(this.posture.isVideo){
          this.poses = response.data.poses;
          this.inputPath = this.rootPath + response.data.inputPath;
          this.outputPath = this.rootPath + response.data.outputPath;
        }else{
          this.postureImageKeys = Object.keys(response.data.poses);
          this.poses = this.postureImageKeys.map(key => response.data.poses[key]);

          const inputPath = {}
          const outputPath = {}

          this.postureImageKeys.forEach(key => {
            inputPath[key] = this.rootPath + response.data.inputPath[key];
            outputPath[key] = this.rootPath + response.data.outputPath[key];
          })

          this.inputPath = inputPath;
          this.outputPath = outputPath;
          this.selectedPostureImageKey = this.postureImageKeys[0];


          const postureImageValidationMap = {};
          this.postureImageKeys.forEach(key => {
            postureImageValidationMap[key] = true;
          })
          this.postureImageValidationMap = postureImageValidationMap;
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.isLoading = false;
      })
    },
    startDragging: function(){
      this.isDragging = true;
      window.addEventListener('mouseup', this.endDragging);
    },
    rotatePosture: function(e){
      if(this.isDragging){
        this.pitch -= e.movementX*0.005;
        this.roll -= e.movementY*0.005;
      }
    },
    scaleGraph: function(e){
      this.cameraPosition *= (1.0 + e.deltaY*0.0005);
    },
    endDragging: function(){
      window.removeEventListener('mouseup', this.endDragging);
      this.isDragging = false;
    },
    updatePosture: function(){
      this.axios.put('/api/posture', this.posture).then(() => {

      }).catch(error => {
        console.log(error);
      })
    },
    updatePostureAttribute: function(key){
      this.axios.put(`/api/posture/${key}`, {
        ...this.posture,
      }).then(() => {

      }).catch(error => {
        console.log(error);
        alert('姿勢分析レポート更新に失敗しました');
      })
    },
    downloadPose: function(){
      this.isDownloading = true;
      this.axios.get(
        `/api/download/posture/${this.id}`,
        {
          responseType: "blob"
        },
      ).then(response => {
        const blob = new Blob([response.data], {
          type: response.data.type
        });
        let fileName = `${this.posture.name}.xlsx`;
        saveAs(blob, fileName);
      }).finally(() => {
        this.isDownloading = false;
      });
    },
    
    updateCurrentVideoPosition: function(e){
      const video = e?.target;
      if(!video || isNaN(video.currentTime) || isNaN(video.duration)){
        this.currentVideoPosition = 0;
        return;
      }
      this.currentVideoPosition = video.currentTime/video.duration;
    },
    selectPostureReport: function(posture){
      if(this.id == posture.id){
        return;
      }
      this.$router.push(`/posture/${posture.id}`);
    },
    selectAdditionalImages: function(e){
      var files = Array.from(e.dataTransfer?.files ?? e);
      files = files.filter(f => f.size <= this.maxFileSize*1000*1000 && f.type.startsWith('image/'));
      if(files.length == 0){
        return;
      }

      const params = new FormData();
      files.forEach(f => {
        params.append('files', f);
      });
      params.append(
        'posture_data_form', 
        JSON.stringify(this.posture)
      );

      this.isLoading = true;

      this.axios.post(
        `/api/posture/image`,
        params,
        {
          headers: {
            'content-type': 'multipart/form-data',
          },
        }
      ).then(() => {
        this.fetchAll();
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.file-button{
  cursor: pointer;
  &:hover{
    opacity: 0.8;
  }
  &:active{
    opacity: 0.4;
  }
}

.selectable-image{
  cursor: pointer;
  height: 30vh;
  &:hover{
    opacity: 0.8;
  }
  &.selected{
    outline: 3px solid #FF33CC;
    outline-offset: -3px;
  }
}
</style>